import {ERROR_BACKGROUND, ERROR_COLOR} from "../../../../../../../themes/themeConfigurator";

const styles = (theme) => ({
  expiredChipContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(1)
    }
  },
  expiredChip: {
    color: ERROR_COLOR,
    background: ERROR_BACKGROUND,
    fontSize: 12,
    height: 18,
  }
});

export default styles;